import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsLoaderService {
    private static loading = false;
    private static loaded = false;
    private static loadPromise: Promise<void> | null = null;

    constructor() {
    }

    /**
     * Wait for Google Maps API to be ready (loaded from index.html)
     * Returns a promise that resolves when the API is ready
     */
    load(): Promise<void> {
        // If already loaded, resolve immediately
        if (GoogleMapsLoaderService.loaded) {
            return Promise.resolve();
        }

        // If currently waiting, return the existing promise
        if (GoogleMapsLoaderService.loadPromise) {
            return GoogleMapsLoaderService.loadPromise;
        }

        // Check if already loaded in window
        if (typeof google !== 'undefined' && google.maps) {
            GoogleMapsLoaderService.loaded = true;
            return Promise.resolve();
        }

        // Wait for the script that's loading in index.html
        GoogleMapsLoaderService.loading = true;
        GoogleMapsLoaderService.loadPromise = new Promise<void>((resolve, reject) => {
            const checkInterval = setInterval(() => {
                if (typeof google !== 'undefined' && google.maps) {
                    clearInterval(checkInterval);
                    GoogleMapsLoaderService.loaded = true;
                    GoogleMapsLoaderService.loading = false;
                    resolve();
                }
            }, 50);

            // Timeout after 10 seconds
            setTimeout(() => {
                clearInterval(checkInterval);
                if (!GoogleMapsLoaderService.loaded) {
                    GoogleMapsLoaderService.loading = false;
                    console.error('Google Maps API failed to load within 10 seconds');
                    reject(new Error('Google Maps API load timeout'));
                }
            }, 10000);
        });

        return GoogleMapsLoaderService.loadPromise;
    }

    /**
     * Check if Google Maps API is loaded
     */
    isLoaded(): boolean {
        return GoogleMapsLoaderService.loaded || (typeof google !== 'undefined' && !!google.maps);
    }
}
